<app-dashboard-header [title]="'work comp partner portal'" [dashboardType]="dashboardType"></app-dashboard-header>
<div class="bg-light-blue w-full pb-6">
  <p class="md:text-3xl text-xl text-center pt-6 pb-4 font-semibold">
    Account Preferences
  </p>
  <app-account-personal-info-form
    [form]="accountForm"
    [dashboardRoute]="dashboardType"
    [showFaxNumberField]="true"
    [showAddressFields]="true"
    [stateOptions]="states"
    [phoneValidationErrorKey]="'pattern'"
    (saveRequested)="onPreferencesFormSubmit()"
    (cancelRequested)="onPreferencesCancel()"
    (changePasswordRequested)="openChangePasswordModal()"
  ></app-account-personal-info-form>
  <form [formGroup]="companyInfoForm" (ngSubmit)="onCompanyInfoFormSubmit()" class="max-w-[98%] mx-auto">
    <mat-card class="personal-details-container overflow-x-auto w-full mt-1 mb-8 border-2 p-4 ml-auto mr-auto bg-white" style="border-radius: 8px">
      <mat-card-content>
        <div class="mt-2 mb-4">
          <p class="text-2xl mb-2 font-bold">Company Information</p>
          <hr class="bg-green h-[3px] border-none">
        </div>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div class="col-span-1">
            <label for="firstName" class="form-label">Manager First Name</label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="managerFirstName" required>
              @if (companyInfoForm.get('managerFirstName')?.hasError('required')) {
                <mat-error>Manager First Name is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="lastName" class="form-label">Manager Last Name</label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="managerLastName" required>
              @if (companyInfoForm.get('managerLastName')?.hasError('required')) {
                <mat-error>Manager Last Name is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="email" class="form-label">Manager Email</label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="managerEmail" required email>
              @if (companyInfoForm.get('managerEmail')?.hasError('required')) {
                <mat-error>Manager Email is required.</mat-error>
              }
              @if (companyInfoForm.get('managerEmail')?.hasError('email')) {
                <mat-error>Please enter a valid email address.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="companyName" class="form-label">Company Name</label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="managerCompanyName" required>
              @if (companyInfoForm.get('managerCompanyName')?.hasError('required')) {
                <mat-error>Company Name is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="faxNumber" class="form-label">Fax # for Information</label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="managerContactFaxNumber" type="tel" required>
              @if (companyInfoForm .get('managerContactFaxNumber')?.hasError('pattern')) {
                <mat-error>Please enter a 10-digit fax number.</mat-error>
              }
              @if (companyInfoForm.get('managerContactFaxNumber')?.hasError('required')) {
                <mat-error>Fax # for Information is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="faxNumber" class="form-label">Fax # for Chart Note</label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="managerChartNotesFaxNumber" type="tel" required>
              @if (companyInfoForm.get('managerChartNotesFaxNumber')?.hasError('pattern')) {
                <mat-error>Please enter a 10-digit fax number.</mat-error>
              }
              @if (companyInfoForm.get('managerChartNotesFaxNumber')?.hasError('required')) {
                <mat-error>Fax # for Chart Note is required.</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        @if (companyInfoForm.dirty) {
          <div class="flex justify-end space-x-4">
            <button class="text-gray-800 bg-gray-300 hover:bg-gray-400 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
              style="margin-right: 5px;"
              type="button"
              (click)="onCompanyInfoCancel()"
              >Cancel
            </button>
            <button class="text-white bg-black hover:bg-blue-800 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
              type="submit">Save
            </button>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </form>
  <app-contact-us-info [dashboardType]="dashboardType"></app-contact-us-info>
</div>
